import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CallGmao, Personne, TechnicienSav } from 'src/app/model/call/call.model';
import { ContratSav, Installation, Proprietaire } from 'src/app/model/installation/installation.model';
import { Suivi } from 'src/app/model/installation/interventions.model';
import { Personnes, SavSuivi } from 'src/app/model/suiviCall/suiviCall';
import { CallService } from 'src/app/services/http/call/call.service';
import { UserService } from 'src/app/services/http/user/user.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-call-rapport',
  templateUrl: './call-rapport.component.html',
  styleUrls: ['./call-rapport.component.scss']
})
export class CallRapportComponent implements OnChanges {

  /**
   * Selected installation
   */
  @Input() installation!: Installation;

  /**
   * id sav suivi for edition (if new : -1)
   */
  @Input() suiviId !: number;

  @Input() detailAppel : SavSuivi = new SavSuivi;




  constructor(private service: CallService, private utilsService: UtilsService) { }

  /**
 * List of techniciens sav
 */
  listTechniciensSav !: TechnicienSav[];
  /**
   * Contract set for the installation
   */
  public contrat !: ContratSav;

  /**
   * Date to show on datetime selector (default is now)
   */
  public dateIntervention !: string;

  /**
   * People linked to installation
   */
  public peopleInstal !: Proprietaire[];
  /**
   * All people
   */
  public people !: Personne[];

  public selectedPersonne !: Personne | null;

  public filteredPeople !: Personne[];

  // use for edition mode
  callId !: string;
  
  name !: Personnes;

  // call state
  public callGmao !: CallGmao;

  public confirmMessage : string = "";



  ngOnChanges(changes: SimpleChanges): void {
     /** Load all the technicians sav */
     this.service.getIntervenantsSavList().subscribe((liste) => {
      this.listTechniciensSav = liste;
    });

    this.dateIntervention = this.setDate(new Date());

    /** Load all people */
    this.service.getPeopleList().subscribe((liste) => {
      this.people = liste.personnes;
      this.filteredPeople = this.people;
      if (this.suiviId > 0) {
        // there is an id (not -1) it's editing mode
        this.callId = this.suiviId.toString();
  
        this.selectPerson(this.detailAppel.id_appelant);
          this.dateIntervention = this.setDate(new Date(this.detailAppel.date_debut))
  
        this.getCallState();
  
      }
    });
    if (this.installation && changes.installation) {
      this.service.getContratSav((this.installation.id_installation).toString()).subscribe((contrat) => {
        this.contrat = contrat;
      });
      /** Load list of people linked to the installation */
      this.service.getPeopleInstallList(this.installation.id_installation).subscribe((liste) => {
        this.peopleInstal = liste;

      });
    }
  }




  /**
   * Method called when the user clicks the submit button
   * @param f the NgForm that the user filled
   */
  onSubmit(f: NgForm) {
    console.log(f.value)
    var formData: any = new FormData();
    var isFacturable: number = 0;
    var isInterAPrevoir: boolean = false;
    var isTermine: number = 0;
    var isInterEffectuee: boolean = false;
    if (f.value.facturable) { isFacturable = 1; }
    if (f.value.interAprevoir) { isInterAPrevoir = true; }
    if (f.value.termine) { isTermine = 1; }
    if (f.value.interEffectuee) { isInterEffectuee = true }
    var duree: number = 0;
    duree = Number(f.value.duree);
    var date_debut = new Date(f.value.callDate);
    var date_formate = date_debut.toUTCString();
    console.log(date_formate);
    var id_installation = this.suiviId;
    if (this.installation) {
      id_installation = this.installation.id_installation
    }
    var id_personne = -1;
    if (this.selectedPersonne) {
      id_personne = this.selectedPersonne.id_personne
    }
    var id_action = -1
    if(this.suiviId > 0){
      id_action = this.detailAppel.actions[0].id_sav_action
    }
    var arrayJ: any =
    {
      "id_installation": id_installation,
      "id_appelant": id_personne,
      "duree": duree,
      "facturable": isFacturable,
      "tarif_weekend": 0,
      "termine": isTermine,
      "date_debut": date_formate,
      "numero_facture": f.value.numFacture,
      "commentaires_facturation": f.value.commentaire,
      "actions": [
        {
          "uniqueID": "gmao",
          "nom_action": f.value.title,
          "descriptif": f.value.description,
          "deplacement_done": isInterEffectuee,
          "deplacement_to_do": isInterAPrevoir,
          "id_mat_unite": -1,
          "id_sav_action": id_action
        }
      ],
      "intervenants": [],
      "id_sav_suivi": this.suiviId
    }
    this.listTechniciensSav.forEach(tech => {
      arrayJ.intervenants.push({
        "id_personne": tech.ID_PERSONNE,
        "deleted": !f.value[tech.ID_PERSONNE]
      })
    })
    console.log(arrayJ);
    formData.append("sav_suivi", JSON.stringify(arrayJ))
    this.service.postCall(formData).subscribe(
      (data: any) => {
        console.log(data);
        this.suiviId = data.result.id_sav_suivi;
        if(data.result.error_message[0]=="Success"){
          this.confirmMessage = "Enregistrement réussi";
        }else{
          this.confirmMessage = "Enregistrement échoué";
        }
        // this.router.navigate(['message', this.identifiant]);
      },
      (failure: any) => {
        console.log(failure);
      }
    );
  }

  /**
   * 
   * @returns 
   */
  isFacturable(): boolean {
    if(this.detailAppel.facturable && this.detailAppel.facturable == 0){
      return false;
    }else if (! this.detailAppel.facturable && this.contrat) {
      return this.contrat.id_contrat_sav < 0
    } else {
      return true;
    }
  }

  isTermine(): boolean {
    if(this.detailAppel.termine && this.detailAppel.termine == 1){
      return true;
    }else{
      return false
    }
  }

  setDate( callDate : Date): string {
    let year = callDate.getFullYear();
    let month = (callDate.getMonth() + 1).toString();
    month = callDate.getMonth() + 1 < 10 ? '0' + month : month;
    let day = callDate.getDate().toString();
    day = callDate.getDate() < 10 ? '0' + day : day;
    let hour = callDate.getHours().toString();
    hour = callDate.getHours() < 10 ? '0' + hour : hour
    let minute = callDate.getMinutes().toString();
    minute = callDate.getMinutes() < 10 ? '0' + minute : minute
    let value = year + '-' + month + '-' + day + 'T' + hour + ':' + minute;
    return value;
  }


  /** Handler so that user can filter the people select by typing characters in the select search field  */
  onKey(event: any) {
    this.filteredPeople = this.searchPeople(event.target.value);
  }

  /** Filtrer les installations en cherchant dans le nom de l'installation, le propriétaire, et la ville  */
  searchPeople(value: string) {
    let filter = value.toLowerCase();
    return this.people.filter(person =>
      person.prenom_nom.toLowerCase().includes(filter));
  }

  getPerson(event: any) {
    this.selectedPersonne = event.value;
  }

  /**
   * select interlocuteur in installation's owner list
   * @param id id of Owner
   */
  selectPerson(id: number) {
    let selection = this.people.filter(person =>
      person.id_personne == id);
    this.selectedPersonne = selection[0];
  }

  checkTech(id: number) {
    if (this.suiviId > 0 && this.detailAppel.intervenants) {
      return this.detailAppel.intervenants.filter(
        intervenant =>
        intervenant.id_personne == id
      ).length>0
    } else if(this.suiviId < 0) {
      return id == Number(localStorage.getItem('idUser'));
    } else {
      return false
    }
  }

  // ----------Call state
  public submitValidation(isOk: boolean) {
    if (!this.callGmao) {
      this.callGmao = new CallGmao;
    }
    this.callGmao.call_state = isOk;
    this.callGmao.call_id = Number(this.callId);
    this.service.postValidation(this.callGmao).subscribe((validation) => {
      console.log(validation)
      this.getCallState();
    }
    )

  }

  public getCallState() {
    this.service.getCallStateData((this.callId)).subscribe((callState) => {
      if (callState[0]) {
        this.callGmao = callState[0];
        this.callGmao.new = false;
      }

    })
  }

  /** Format pretty dates */
  getNiceDate(toFormat: string): string {
    return this.utilsService.getNiceDateHeure(toFormat);
  }

}
